import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12 order-xl-1" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Maintenance")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_10 = { class: "is-mobile" }
const _hoisted_11 = { class: "d-flex m-3 pb-2" }
const _hoisted_12 = { class: "is-web" }
const _hoisted_13 = { class: "d-flex justify-content-end m-3 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsComponent = _resolveComponent("DetailsComponent")!
  const _component_PartsComponent = _resolveComponent("PartsComponent")!
  const _component_CustomField = _resolveComponent("CustomField")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", null, [
            _createVNode(_component_DetailsComponent, {
              modelValue: _ctx.maintenance,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.maintenance) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_component_PartsComponent, {
              modelValue: _ctx.maintenance.part_supplied,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maintenance.part_supplied) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_7,
            (_ctx.maintenance.custom_field)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_CustomField, {
                    modelValue: _ctx.maintenance.custom_field,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maintenance.custom_field) = $event)),
                    "view-only": false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_n_button, {
                  class: "mr-3 flex-fill",
                  type: "primary",
                  onClick: _ctx.save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SAVE ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_n_button, {
                  class: "flex-fill",
                  strong: "",
                  secondary: "",
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" BACK ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_n_button, {
                  class: "mr-3",
                  type: "primary",
                  onClick: _ctx.save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SAVE ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_n_button, {
                  class: "",
                  strong: "",
                  secondary: "",
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" BACK ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}